import React from "react";
import { TableCell, TableRow } from "@mui/material";
import AnnouncementsTableRow from "./AnnouncementsTableRow";
import EntityListTable from "../../helpers/EntityListTable";
import TableCreateButton from "../../helpers/TableCreateButton";

const AnnouncementsTable = ({
  announcements,
  currentPage,
  onPageButtonClicked,
}) => {
  const displayedAnnouncements = announcements.slice(0, 10);
  const hasNextPage = announcements.length === 11;

  return (
    <>
      <TableCreateButton link="create"/>
      <EntityListTable
        currentPage={currentPage}
        hasNextPage={hasNextPage}
        onPageButtonClicked={onPageButtonClicked}
        tableHeaderComponent={
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell align="right">Label</TableCell>
            <TableCell align="right">Sent</TableCell>
          </TableRow>
        }
      >
        {displayedAnnouncements.map(
          (announcement) => <AnnouncementsTableRow
            key={announcement.announcementEntityId}
            announcement={announcement}
          />,
        )}
      </EntityListTable>
    </>
  );
};

export default AnnouncementsTable;
